export default "__VITE_ASSET__Cw36DJdA__"